import BigCard from 'Components/BigCard/BigCard';
import AvailabilityChart from 'Components/DashboardCharts/AvailabilityChart/AvailabilityChart';
import PageHeader from 'Components/PageHeader/PageHeader';
import SmallCard from 'Components/SmallCard/SmallCard';

import { useNavigate } from 'react-router-dom';

import classes from './AvailabilitySection.module.scss';
import { useGlobalState } from 'Providers/GlobalStateProvider';
import { statsQuerySerialiser } from '~/features/stats-details/query-parsers';
import { getAvailabilityColor } from 'Utils/getAvailabilityColor';

interface ILiftStatsAvailability {
  count?: number;
  lift_count?: number;
  unavailable?: number;
  available?: number;
  total?: number;
  percentage: number;
  bracket?: LiftStatus.Schemas.IStatsBracketDto[];
}

interface IAvailabilitySectionProps {
  loading: boolean;
  liftAvailability?: ILiftStatsAvailability;
  intercomAvailability?: ILiftStatsAvailability;
}

const AvailabilitySection = ({
  loading,
  liftAvailability,
  intercomAvailability,
}: IAvailabilitySectionProps) => {
  const [globalState] = useGlobalState();

  const navigate = useNavigate();
  const numberFormat = new Intl.NumberFormat(globalState.locale, {
    maximumFractionDigits: 2,
  });

  return (
    <div className={classes.section}>
      <PageHeader title="Beschikbaarheid"></PageHeader>

      <div className={classes.cards}>
        <SmallCard
          loading={loading}
          data={numberFormat.format(liftAvailability?.percentage ?? 0)}
          title={'Beschikbaarheid liften'}
          tooltip={'De totale beschikbaarheid van de lift installaties'}
          percent={true}
          color={getAvailabilityColor(liftAvailability?.percentage ?? 0)}
          showDetails={() =>
            navigate(
              [
                '/stats-details/liftAvailability',
                statsQuerySerialiser({
                  statsType: 'historic',
                }),
              ].join('')
            )
          }
        />

        <SmallCard
          loading={loading}
          data={numberFormat.format(intercomAvailability?.percentage ?? 0)}
          title={'Beschikbaarheid spreekluister'}
          tooltip={'De beschikbaarheid van de spreekluistersystemen'}
          percent={true}
          color={getAvailabilityColor(intercomAvailability?.percentage ?? 0)}
          showDetails={() =>
            navigate(
              [
                '/stats-details/intercomAvailability',
                statsQuerySerialiser({
                  statsType: 'historic',
                }),
              ].join('')
            )
          }
        />
      </div>

      <div className={classes.chart}>
        <BigCard
          title=""
          loading={loading}
          chart={
            <AvailabilityChart
              intercom={{ bracket: intercomAvailability?.bracket || [] }}
              lifts={{ bracket: liftAvailability?.bracket || [] }}
              showDetails={(type, bracket) => {
                const [lower, upper] = bracket;

                navigate(
                  [
                    '/stats-details',
                    `/${type === 'lifts' ? 'liftAvailability' : 'intercomAvailability'}`,
                    statsQuerySerialiser({
                      statsType: 'historic',
                      lower: lower ?? null,
                      upper: upper ?? null,
                    }),
                  ].join('')
                );
              }}
            />
          }
        />
      </div>
    </div>
  );
};

export default AvailabilitySection;
